<template>
  <a-popover
    :title="false"
    :footer="false"
    overlayClassName="support-popover-overlay"
    placement="right"
  >
    <template slot="content">
      <div class="dash-text__16 dash-text__500">
        {{ $t("Support info") }}
      </div>
    </template>

    <div class="support-button">
      <a
        class="dash-text__13 dash-text__600"
        href="https://t.me/thirdopinion_support_bot"
        target="_blank"
      >
        {{ $t("Support") }}
      </a>
    </div>
  </a-popover>
</template>

<script>
export default {};
</script>
